<template>
  <div class="keywordrole" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
      <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
          <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
      </v-snackbar>
      <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
        <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
      </v-snackbar>
      <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
      <template>
        <v-toolbar flat class="rounded-lg">
          <v-toolbar-title style="margin-left: 20px;"><v-icon class="mx-2">mdi-keyboard-variant</v-icon>{{this.$store.state.title}} </v-toolbar-title> 
            <v-spacer></v-spacer>
          <v-flex lg3>
            <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
          </v-flex>
          <!--v-dialog-->
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                outlined
                rounded
                v-show=insertact
                small
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                >
                Add New 
                <v-icon class="ml-2">mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
              <v-card-text>
                
                <v-form class="ml-2" ref="form" lazy-validation>
                <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined dense :rules="keywordRolenaerules" v-model="keywordRoleName" label="Role Name" 
                        hint="Input Username Display Name" persistent-hint>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-select dense outlined item-text="active" item-value="value" v-model="keywordRoleStatus" :items="itemKeywordRoleStatus" 
                        hint="User type of famous person" persistent-hint></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" width="330px"> 
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-avatar3 my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar>
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Deletion
              </div>
              <v-card-text class="align-center justify-center mt-2">
                Are you sure you want to permanently delete this item?
              </v-card-text> 
              <v-divider class="mt-4" style=""></v-divider>
              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                  OK
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <v-data-table
        :headers="headers"
        :items="keywordrole"
        :search="search"
        sort-by="rolename"
        class="table-user ml-6 mr-6 mt-4 rounded-lg"
        :loading="tableLoading"
        loading-text="Loading data..."
        >
        
          <template v-slot:item.ROLE_STATUS_TEXT="{ item }">
            <v-chip :color="getColor(item.ROLE_STATUS_TEXT)"  text-color="white" label small pill>
              {{ item.ROLE_STATUS_TEXT }}
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon class="mr-2" small v-show=updateact  @click="editItem(item.SEQ_ID)">
              mdi-pencil
            </v-icon>
            <v-icon small v-show=deleteact @click="deleteItem(item.SEQ_ID)">
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
      </v-data-table>
        <Notification  ref="alert"></Notification>
  </div>
</template>
<script>
import axios from "axios";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",
      
      deleteact: false,
        insertact: false,
        updateact: false,
        viewact: false,
      keywordRolenaerules: [
          v => !!v || ' Role Name is required',
          v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input hanya boleh berisi huruf, angka, spasi, dan spesial caracter (.@_-)',
        ],
      search: '',
      dialog: false,
      dialogDelete: false,
      keywordRoleName: '',
      keywordRoleStatus: 0,
      itemKeywordRoleStatus: [
        {value: 1, active: 'Enabled'},
        {value: 0, active: 'Disabled'}
      ],
      headers: [
        { text: 'Role Name', value: 'ROLE_NAME' },
        { text: 'Role Status', value: 'ROLE_STATUS_TEXT' },
        { text: 'Created Date', value: 'SYS_CREATED_DATE' },
        { text: 'Created By', value: 'SYS_CREATED_BY' },
        { text: 'Update Date', value: 'SYS_UPDATED_DATE' },
        { text: 'Update By', value: 'SYS_UPDATED_BY' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      keywordrole: [],
      id_keywordrole:'',
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Keyword Role' : 'Update Keyword Role'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      getColor(status) {
        return status === 'Disabled' ? 'red' : 'green';
      },
      async initialize () {
        this.tableLoading = true;
        axios.get("keyword-role",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            // this.keywordrole = response.data.role_keyword
            let res = decryptionData(response.data.token);
            this.keywordrole = res.role_keyword
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
            
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      editItem (item) {
        // alert(item);
        this.id_keywordrole = item
        this.editedIndex = 1
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "keyword-role-id",
          data: {
            seq_id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            console.log(response.data);
            
            const dat = decryptionData(response.data.token);
            this.id_keywordrole = dat.SEQ_ID;
            this.keywordRoleName = dat.ROLE_NAME
            this.keywordRoleStatus = dat.ROLE_STATUS
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      deleteItem (item) {   
        // alert(item);
        this.id_keywordrole = item
        this.editedIndex = this.keywordrole.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
        // alert( this.editedItem);
      },
      deleteItemConfirm () {
        this.keywordrole.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "keyword-role/delete",
          data: {
            seq_id: this.id_keywordrole
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      close () {
        this.dialog = false
        this.id_keywordrole = '';
        this.keywordRoleName =''
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      save () {
        // edit 
        if (this.editedIndex == -1) { 
          this.id_keywordrole = '';
        }
        this.keywordrole.push(this.editedItem)
        axios.put("keyword-role/action", 
          {
            seq_id:this.id_keywordrole,
            role_name:this.keywordRoleName,
            role_name_lama:this.keywordRoleName,
            role_status:this.keywordRoleStatus,
          },
          {headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          )
        .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                this.$router.push('/keywordrole');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
          })
        .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    case 400:
                          this.alertFailed = true;
                          this.alert_err_attention =  e.response.data.msg;
                          this.btnload = false
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
    },
  }
</script>

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>
